<template>
    <div class="privacy-container">
      <h1>隱私權政策</h1>
  
      <p>
        感謝您使用雲林縣政府「雲林農情通」行動應用服務。 本行動應用服務重視您的個人隱私權，並致力於妥善保護您所提供的個人資料， 為協助您瞭解「雲林農情通」如何蒐集、運用及保護您的個人資訊， 請詳閱以下隱私權政策內容。
      </p>
  
      <h2>一、隱私權政策適用範圍</h2>
      <p>
        本隱私權政策適用於您在使用「雲林農情通」行動應用服務過程中， 所涉及之個人資料蒐集、處理、利用及刪除行為。
      </p>
  
      <h2>二、個人資料之蒐集、處理及利用及刪除方式</h2>
      <ul>
        <li>蒐集項目：姓名、手機號碼（作為身分驗證與服務識別之用途）、使用者所在地理位置。</li>
        <li>未經您本人同意，不會任意修改或刪除您的個人資料，但下列情形不在此限：
          <ol>
            <li>依法令或合法程序辦理。</li>
            <li>使用行為違反服務相關規定。</li>
            <li>為保護其他使用者或第三人之合法權益。</li>
            <li>為維護本服務正常運作。</li>
          </ol>
        </li>
        <li>個人資料利用說明：
          <ol>
            <li>期間：本府營運期間及依法令規定之保存期間。</li>
            <li>地區：本府營運地區。</li>
            <li>對象：本府及受委託之關係企業與合作廠商。</li>
            <li>方式：提供活動資訊、市場調查或服務提醒訊息。</li>
            <li>蒐集目的：調查、統計與研究分析、資訊服務、資訊與資料庫管理、 資訊安全管理、會員管理及其他諮詢與顧問服務。</li>
          </ol>
        </li>
      </ul>
      <p>
        您得依個人資料保護法行使查詢、閱覽、補充更正、停止利用或刪除等權利， 本府將依法審酌是否受理。
      </p>
      <p>
        本府將以嚴密的資訊安全措施保護您的個人資料， 並要求受委託單位遵守保密義務。
      </p>
  
      <h2>三、與第三人共用個人資料之政策</h2>
      <p>
        本行動應用服務絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。前項但書之情形包括不限於： 
      </p>
      <ul>
        <ol>
          <li>配合司法機關調查。</li>
          <li>配合主管機關依法執行職務。</li>
          <li>為維護本服務管理與安全所必要。</li>
        </ol>
      </ul>

  
      <h2>四、設備權限使用說明</h2>
      <p>
        「雲林農情通」於提供服務過程中，將依功能需求向使用者之行動裝置請求相關設備權限。使用者可於裝置系統設定中自行選擇是否授予部分或全部權限。各項權限之使用目的與方式，說明如下： 
      </p>
      <ul>
        <ol>
          <li>定位：用於判斷使用者所在區域，以提供鄰近微氣候感測器之相關資訊與服務，系統僅於提供功能服務時使用定位資訊，不會影響使用者其他資料。若未授權定位功能，僅影響與位置相關之服務內容，不影響本應用程式其他功能之正常使用。</li>
          <li>通知：用於接收本應用程式推播之相關訊息，如政府公告或最新消息等。若未授權通知功能，僅影響推播訊息之接收，不影響本應用程式其他功能之正常使用。</li>
        </ol>
      </ul>
  
      <h2>五、使用者應盡之義務</h2>
      <ul>
        <li>提供不實資料者，本服務得拒絕其使用權限。</li>
        <li>帳號安全須由使用者自行妥善保管。</li>
        <li>如帳號遭盜用，請立即通知服務信箱。</li>
        <li>使用者應遵守相關法令，並對帳號行為負責。</li>
      </ul>

      <h2>六、網站對外的相關連結</h2>
      <ul>
        <li>本政策不適用於經由本行動應用服務連結至之外部網站或其他政府機關及第三方行動應用服務。 該等外部網站均有其各自之隱私權政策，本行動應用服務不負任何連帶責任。</li>
      </ul>

      <h2>七、Cookie 使用說明</h2>
      <ul>
        <li>為提供更完善的服務，本平台可能使用 Cookie 以分析使用行為與改善服務品質。</li>
      </ul>

      <h2>八、隱私權政策之修正與諮詢</h2>
      <ul>
        <li>本網站隱私權保護政策將因應需求進行修正，修正後的內容將公告於本網站，並於公告後生效。如果您對於本網站的資訊安全政策宣告有任何疑問，請利用本網站「聯絡我們」與我們聯繫。</li>
        <li>服務信箱： ylhg40118@mail.yunlin.gov.tw</li>
      </ul>

    </div>
  </template>
  
  <script>
  export default {
    name: 'Privacy'
  }
  </script>
  
  <style scoped>
  .privacy-container {
    max-width: 960px;
    margin: auto;
  
    /* 👇 上下 / 左右 padding */
    padding: 40px 24px;
  
    line-height: 1.8;
  }
  
  h1 {
    margin-bottom: 24px;
  }
  
  h2 {
    margin-top: 32px;
  }
  
  h3 {
    margin-top: 24px;
  }
  
  ul,
  ol {
    padding-left: 24px;
  }
  </style>
  